import EventTracker from "/js/components/EventTracker.js";

export default {

  showModal(cls, autoAction = false) {
    let elem = $('.am-modal.' + cls);
    if (elem.length != 0) {
      $('#g-item-manager').addClass('modal-open');
      elem.addClass('in');

      EventTracker.saveData(
        autoAction ? EventTracker.SYSTEM : undefined,
        EventTracker.ACTION_SHOW, elem.attr('data-event-id') ? elem.attr('data-event-id') : cls);
    }
    $('.g-example, .g-hint').prop('disabled', true);
  },

  hideModal(cls, autoAction = false) {
    cls = cls || null;
    let elem = $('.am-modal.' + cls);

    if (cls != null && elem.length > 0) {
      elem.removeClass('in');
      EventTracker.saveData(
        autoAction ? EventTracker.SYSTEM : undefined,
        EventTracker.ACTION_HIDE, elem.attr('data-event-id') ? elem.attr('data-event-id') : cls);

      // check if other modals exists, if not, then it's safe to remove the modal-open class
      if ($('.am-modal.in').length === 0) {
        $('#g-item-manager').removeClass('modal-open');
        $('.g-example, .g-hint').prop('disabled', false);
      }
    } else {
      $('#g-item-manager').removeClass('modal-open');
      $('.am-modal.in').each(function () {
        $(this).removeClass('in');
        EventTracker.saveData(
          autoAction ? EventTracker.SYSTEM : undefined,
          EventTracker.ACTION_HIDE, $(this).attr('data-event-id'));
      });
      $('.g-example, .g-hint').prop('disabled', false);
    }
  },

  getTimeStamp() {
    return (new Date().getTime());
  },
}
